import _ from 'lodash'
import utils from '../utils'

export function createInvoiceSummaryByPayer(invoices) {
  const invoicesByPayer = Object.values(_.groupBy(invoices, inv => inv.payerBankAccount))
  const summary = invoicesByPayer.map(invs => {
    const vendors = Object.values(_.groupBy(invs, inv => inv.payeeTaxID))
      .map(createInvoiceSummaryByVendor)

    return {
      // retrieve 'payer' information
      ..._.pickBy(invs[0], (value, key) => key.startsWith('payer')),
      ...calculateSummary(vendors),
      vendors
    }
  });
  return summary
}

export function createInvoiceSummaryByVendor(invoices, index) {
  return {
    no: index + 1,
    // retrieve 'payee' information
    ..._.pickBy(invoices[0], (value, key) => key.startsWith('payee')),
    ...calculateSummary(invoices),
    paymentDetail: invoices[0].paymentDetail,
    invoices: invoices,
    eWhtRateCount: _.size(_.groupBy(invoices, inv => inv.whtRate))
  }
}

export function calculateSummary (list) {
  return {
    invoiceTotalNetAmount: _.sumBy(list, o => o.invoiceTotalNetAmount),
    invoiceBaseAmount: _.sumBy(list, o => o.invoiceBaseAmount),
    invoiceVatAmount: _.sumBy(list, o => o.invoiceVatAmount),
    invoiceTotalAmount: _.sumBy(list, o => o.invoiceTotalAmount),
    whtAmount: _.sumBy(list, o => o.whtAmount),
  }
}

export function addItemInfo (inv, seqNo) {
  let data = ''

  // ---- LINE 3 ----
  // ลำดับ	ชื่อ Field ธนาคาร	ความหมาย	ความหมาย/ข้อจำกัด	จำนวน Characters
  // 1	T			1
  data += 'T'
  // 2	WHT Form	"05 : ภงด.3
  // 07 : ภงด.53"		2
  data += utils.convertWhtCode(inv.whtCode) // WHT Form, mapping 3 => 05 and 53 => 07
  // 3	ลำดับรายการ		ไม่มีต่า ให้แสดงเป็นค่าว่าง	10
  data += utils.padText(seqNo, 10) // item no. (i)
  // 4	Tax Rate	อัตราภาษีสำหรับภาษีหัก ณ ที่จ่าย		6
  data += utils.padDecimal(inv.whtRate / 100, 6) // Tax Rate ex 0.75 => 000.75
  // 5	Code Type of Tax Deducted	รหัสประเภทของภาษีหัก ณ ที่จ่าย	"- ข้อมูลตามที่สรรพากรกำหนด
  // - ดูข้อมูลเพิ่มเติมที่ Sheet ประเภทภาษีหัก ณ ที่จ่าย"	3
  data += utils.padNumber(inv.whtCode, 3)
  // 6	Type of Tax Deducted	ประเภทของภาษีหัก ณ ที่จ่าย	"- ข้อมูลตามที่สรรพากรกำหนด
  // - ดูข้อมูลเพิ่มเติมที่ Sheet ประเภทภาษีหัก ณ ที่จ่าย"	37
  data += utils.padText(inv.whtName, 37)
  // 7	Tax Amt Bef VAT	จำนวนเงินก่อนคิดภาษีมูลค่าเพิ่ม	เช่น ยอดเงิน 1,000 บาท ให้แสดงเป็น 0000001000.00	13
  data += utils.padDecimal(inv.invoiceBaseAmount, 13)
  // 8	Tax Deducted	จำนวนเงินภาษีหัก ณ ที่จ่าย	เช่น ยอดเงิน 1,000 บาท ให้แสดงเป็น 0000001000.00	13
  data += utils.padDecimal(inv.whtAmount, 13)
  // 9	Tax Amt After VAT	จำนวนเงินรวมภาษีมูลค่าเพิ่มแล้ว	เช่น ยอดเงิน 1,000 บาท ให้แสดงเป็น 0000001000.00	13
  data += utils.padDecimal(inv.invoiceTotalNetAmount, 13)
  // 10	Tax Condition	"เงื่อนไขการหักภาษี
  // 1 : หักภาษี ณ ที่จ่าย
  // 2 : ออกภาษีให้ตลอดไป
  // 3 : ออกภาษีให้ครั้งเดียว"		1
  data += utils.padText(inv.whtConditionType, 1)
  // 11	Enter	จบข้อมูลในบรรทัด		
  data += '\n'

  return data
}

export function addMobileInfo (summary) {
  let data = ''
  /*
  ---- LINE 4 ----
  1	M		1
  2	SMS Tel.No	เบอร์โทรศัพท์มือถือของคู่ค้า  (จำเป็นต้องใส่กรณีที่มี Credit Advice ผ่านทาง SMS)	54
  3	SMS Languag 	"TH ภาษาไทย
  EN ภาษาอังกฤษ"	2
  4	Enter		
  */
  data += 'M'
  data += utils.padText(summary.payeeMobile, 54)
  // TODO: require user input
  data += 'TH' // TH or EN
  data += '\n'

  return data
}